import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        sched: {},
        selectedDay: 0,
        days: {},
        week: 4,
        ready: false,
        channel: 'main'
    },
    mutations: {
        addSchedData (state, obj) {
            state.sched[obj.key] = obj.data
        },
        selectDay(state, day) {
            state.selectedDay = day
        },
        addGenDays(state, days) {
            state.days = days
        },
        setReady(state, ready) {
            state.ready = ready
        },
        incWeek(state) {
            if (state.week < 9) {
                state.week++
            }
        },
        decWeek(state) {
            if (state.week > 0) {
                state.week--
            }
        },
        setChannel(state, channel) {
            state.channel = channel
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js